import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var UsbFlashDrive = function UsbFlashDrive(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18 9V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.2401 2 16.9601 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V9m4-3V5m4 1V5M8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2v-5c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 9 17.9201 9 16.8 9H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 10.5198 4 11.0799 4 12.2v5c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22"
    })
  }));
};
export default UsbFlashDrive;